import { Controller } from "stimulus"
import $ from 'jquery';

// require("select2/dist/css/select2")
// require("select2-bootstrap-theme/dist/select2-bootstrap")

export default class extends Controller {

    initialize() {
        let element = this.element;
        $.ajax({
            url: location.origin + '/' + sessionStorage.getItem('locale') + '/frequently-answer.json',
            data: {},
            type: 'GET',
            success: (data) => {
                let html = '';
                data.map(faq => {
                    html += `
                     <div class="card mb-1">
                              <div class="faq-item" id="headingOne">
                                  <button class="faq-question" type="button" data-toggle="collapse" data-target="#faq_${faq.id}" aria-expanded="true" aria-controls="collapseOne">
                                    ${faq.title}
                                    <span class="faq-icon"></span>
                                  </button>
                              </div>
                              <div id="faq_${faq.id}" class="collapse" aria-labelledby="headingOne" data-parent="#${element.id}">
                                <div class="card-body">
                                  ${faq.descriptions.body}
                                </div>
                              </div>
                            </div>
                    `;
                });
                element.innerHTML = html;

                // Aquí se agrega la lógica para manejar los eventos de clic
                this.setupFaqToggle();
            }
        });
    }

    setupFaqToggle() {
        const faqQuestions = this.element.querySelectorAll('.faq-question');

        faqQuestions.forEach(question => {
            question.addEventListener('click', () => {

                // Toggle active class on the question
                question.classList.toggle('active');


                // Close other open questions
                faqQuestions.forEach(otherQuestion => {
                    if (otherQuestion.classList.contains('active')) {
                        otherQuestion.classList.remove('active');
                    }
                });
            });
        });
    }
}
